import React from "react";

export default function LoadingScreen({ message = "Almost ready — just a moment..." }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black text-white"
    >
      <div className="flex flex-col items-center gap-6 px-8 py-10 rounded-lg bg-black/60 backdrop-blur-sm ring-8 ring-amber-500/10">
        <div className="flex items-center justify-center rounded-full bg-amber-900/20 p-6 shadow-[0_8px_30px_rgba(255,215,0,0.12)] relative">
          {/* Stylized golden logo */}
          <svg
            width="84"
            height="84"
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="animate-pulse"
          >
            <defs>
              <linearGradient id="g1" x1="0" x2="1">
                <stop offset="0" stopColor="#FFD700" stopOpacity="0.98" />
                <stop offset="1" stopColor="#B8860B" stopOpacity="0.95" />
              </linearGradient>
            </defs>
            <circle cx="50" cy="50" r="34" fill="url(#g1)" />
            <path d="M38 66 L62 66 L62 34 L38 34 Z" fill="#5b3400" opacity="0.95" />
            <path d="M46 46 L54 46 L54 54 L46 54 Z" fill="#fff" />
          </svg>

          {/* App icon from public/icon.svg centered inside the gold circle */}
          <img src="/icon.svg" alt="App icon" className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-14 h-14 pointer-events-none" />
        </div>

        <div className="w-32 h-32 rounded-full bg-amber-900/10 flex items-center justify-center">
          <svg
            className="animate-spin text-amber-400 w-20 h-20"
            xmlns="http://www.w3.org/2000/svg"
            width="80"
            height="80"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" strokeOpacity="0.25" />
            <path d="M22 12a10 10 0 0 0-10-10" />
          </svg>
        </div>

        <div className="text-center">
          <div className="text-2xl font-semibold text-amber-200">{message}</div>
          <div className="mt-1 text-base text-amber-100 opacity-90">Hang tight — we’ll be with you shortly.</div>
        </div>
      </div>
    </div>
  );
}
